import React from 'react';
import { useSelector } from 'react-redux';
import VendorBidOfferAndDemandTable from '../../../VendorOfferBids/components/VendorBidOfferAndDemandTable';

const VendorMyDemandBidsTable = () => {
  const { selectedVendor } = useSelector((state) => state.vendorDetailsReducer);

  return (
    <div>
      <VendorBidOfferAndDemandTable
        filter={[
          {
            key: 'bidType',
            value: 'DEMAND',
            type: 'STRING',
            op: 'EQ',
          },
          {
            key: 'bidTrader',
            value: selectedVendor?.id,
            type: 'INT',
            op: 'EQ',
          },
          {
            key: 'bidder',
            value: selectedVendor?.id,
            type: 'INT',
            op: 'NEQ',
          },
        ]}
      />
    </div>
  );
};

export default VendorMyDemandBidsTable;
